import script from "./ClientCoveragePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCoveragePanel.vue?vue&type=script&setup=true&lang=js"

import "./ClientCoveragePanel.vue?vue&type=style&index=0&id=55420044&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55420044"]])

export default __exports__